"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-three/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "about-item" | "about-item about-item-two" | "about-item about-item-three" | "about-item about-item-four" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/icons/about-icon-one.svg" | "/Templates/Doccure/img/icons/about-icon-two.svg" | "/Templates/Doccure/img/icons/about-icon-three.svg" | "/Templates/Doccure/img/icons/about-icon-four.svg" */
    src: string;
    /** Detected variants: "Best Medical Service" | "Expert Medical Team" | "24/7 Instant Support" | "Virtual Consultation" */
    h30Text: ReactNode;
    /** Detected variants: "col-lg-6" */
    divClassName?: string;
    /** Detected variants: "about-avatar" */
    div0ClassName?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "Our expert team delivers trusted, compassionate" */
    p0Text?: ReactNode;
    /** Detected variants: "description" */
    p0ClassName?: string;
};

type AboutSectionSvgsItem = {
    key: Key | null | undefined;
    /** Detected variants: "0 50 37 68 37 32 0 50" | "100 50 64 32 64 68 100 50" */
    points: string;
};
export type HomeThreeAboutSectionGeneratedProps = {
    divDiv0Div0ClassName?: string;
    /** Default: "/Templates/Doccure/img/about/slide-img-1.jpg" */
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "/Templates/Doccure/img/about/slide-img-2.jpg" */
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "fade-up" */
    divDiv0Div0Div1Div0DivDataAos?: string;
    /** Default: "Expert Care for Every Tooth," */
    divDiv0Div0Div1Div0H20H2Text?: ReactNode;
    divDiv0Div0Div1Div0H20H2Visible?: boolean;
    divDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Restore Your Confidence" */
    divDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    /** Default: "From routine cleanings to advanced procedures, our expert team is dedicated to helping achieve & maintain health throughout your life." */
    divDiv0Div0Div1Div0P0PText?: ReactNode;
    divDiv0Div0Div1Div1ClassName?: string;
    /** Default: "#" */
    divDiv0Div0Div1Div2Link0LinkHref?: string;
    divDiv0Div0Div1Div2Link0LinkVisible?: boolean;
    divDiv0Div0Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "More About Us" */
    divDiv0Div0Div1Div2Link0Span0SpanText?: ReactNode;
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "element" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/element-dent-01.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    divImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/element-dent-02.png" */
    divImageWithBasePath1ImageSrc?: string;
    divImageWithBasePath1ImageVisible?: boolean;
    divImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    divImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/about-icon-4.svg" */
    divImageWithBasePath2ImageSrc?: string;
    divImageWithBasePath2ImageVisible?: boolean;
    divImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    aboutSection6s: AboutSection6sItem[];
    aboutSectionSvgs: AboutSectionSvgsItem[];
    aboutSection6sItemWrapper?: (item: AboutSection6sItem, content: ReactNode) => ReactNode;
    aboutSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageVisible?: boolean;
    aboutSection6sImageRenderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sH3Visible?: boolean;
    aboutSection6sH3Renderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    aboutSectionSvgsItemWrapper?: (item: AboutSectionSvgsItem, content: ReactNode) => ReactNode;
    aboutSectionSvgsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeThreeAboutSectionGenerated: FC<HomeThreeAboutSectionGeneratedProps> = ({
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/slide-img-1.jpg",
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/slide-img-2.jpg",
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageProps,
    divDiv0Div0Div1Div0DivDataAos = "fade-up",
    divDiv0Div0Div1Div0H20H2Text = "Expert Care for Every Tooth,",
    divDiv0Div0Div1Div0H20H2Visible,
    divDiv0Div0Div1Div0H20H2Renderer,
    divDiv0Div0Div1Div0H20H2Props,
    divDiv0Div0Div1Div0H20Span0SpanText = "Restore Your Confidence",
    divDiv0Div0Div1Div0P0PText = "From routine cleanings to advanced procedures, our expert team is dedicated to helping achieve & maintain health throughout your life.",
    divDiv0Div0Div1Div2Link0LinkHref = "#",
    divDiv0Div0Div1Div2Link0LinkVisible,
    divDiv0Div0Div1Div2Link0LinkRenderer,
    divDiv0Div0Div1Div2Link0LinkProps,
    divDiv0Div0Div1Div2Link0Span0SpanText = "More About Us",
    divImageWithBasePath0ImageAlt = "element",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/element-dent-01.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    divImageWithBasePath1ImageAlt = "element",
    divImageWithBasePath1ImageSrc = "/Templates/Doccure/img/about/element-dent-02.png",
    divImageWithBasePath1ImageVisible,
    divImageWithBasePath1ImageRenderer,
    divImageWithBasePath1ImageProps,
    divImageWithBasePath2ImageAlt = "element",
    divImageWithBasePath2ImageSrc = "/Templates/Doccure/img/icons/about-icon-4.svg",
    divImageWithBasePath2ImageVisible,
    divImageWithBasePath2ImageRenderer,
    divImageWithBasePath2ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv0Div0ClassName,
    divDiv0Div0Div1Div1ClassName,
    aboutSection6s,
    aboutSectionSvgs,
    aboutSection6sItemWrapper,
    aboutSection6sRenderer,
    aboutSection6sImageVisible,
    aboutSection6sImageRenderer,
    aboutSection6sH3Visible,
    aboutSection6sH3Renderer,
    aboutSection6sImageProps,
    aboutSection6sH3Props,
    aboutSectionSvgsItemWrapper,
    aboutSectionSvgsRenderer,
}) => {
    return (
        <div className="about-section-two section bg-white">
            <div className="container">
                <div className={divDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-6">
                        <div className="about-img-three d-none d-lg-block">
                            <div className="wrapper">
                                <div className="before">
                                    {renderNode(divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage className="content-image" src={divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} {...(divDiv0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} alt="" />
                                    ))}
                                </div>
                                <div className="after">
                                    {renderNode(divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage className="content-image" src={divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageSrc} {...(divDiv0Div0Div0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} alt="" />
                                    ))}
                                </div>
                                <div className="scroller">
                                    <svg className="scroller__thumb" xmlns="http://www.w3.org/2000/svg" width={100} height={100} viewBox="0 0 100 100">
                                        {renderCollectionNode(
                                            aboutSectionSvgs,
                                            (item: AboutSectionSvgsItem) => (
                                                <polygon points={item.points} style={{ fill: "#fff" }} key={item.key} />
                                            ),
                                            aboutSectionSvgsItemWrapper,
                                            aboutSectionSvgsRenderer
                                        )}
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-header aos" data-aos={divDiv0Div0Div1Div0DivDataAos}>
                            {renderNode(divDiv0Div0Div1Div0H20H2Visible, divDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title mb-3" {...(divDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {divDiv0Div0Div1Div0H20H2Text}
                                    <span className="text-primary d-block">{divDiv0Div0Div1Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                            <p>{divDiv0Div0Div1Div0P0PText}</p>
                        </div>
                        <div className={divDiv0Div0Div1Div1ClassName ?? "row g-0"}>
                            {renderCollectionNode(
                                aboutSection6s,
                                (item: AboutSection6sItem) => (
                                    <div className={item.divClassName ?? "col-lg-6"} key={item.key}>
                                        <div className={item.className}>
                                            <div className={item.div0ClassName ?? "about-avatar"}>
                                                {renderItemNode(aboutSection6sImageVisible, aboutSection6sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof aboutSection6sImageProps === "function" ? aboutSection6sImageProps(item) : (aboutSection6sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            {renderItemNode(aboutSection6sH3Visible, aboutSection6sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection6sH3Props === "function" ? aboutSection6sH3Props(item) : (aboutSection6sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p className={item.p0ClassName ?? "description"}>{item.p0Text ?? "Our expert team delivers trusted, compassionate"}</p>
                                        </div>
                                    </div>
                                ),
                                aboutSection6sItemWrapper,
                                aboutSection6sRenderer
                            )}
                        </div>
                        <div className="more-btn">
                            {renderNode(divDiv0Div0Div1Div2Link0LinkVisible, divDiv0Div0Div1Div2Link0LinkRenderer, (
                                <SmartLink href={divDiv0Div0Div1Div2Link0LinkHref} className="btn btn-primary theme-2-btn" {...(divDiv0Div0Div1Div2Link0LinkProps ?? {})}>
                                    <span>
                                        {divDiv0Div0Div1Div2Link0Span0SpanText}
                                        <span className="icon">
                                            <i className="isax isax-arrow-up-34" />
                                        </span>
                                    </span>
                                </SmartLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid element" {...(divImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath1ImageVisible, divImageWithBasePath1ImageRenderer, (
                <SmartImage src={divImageWithBasePath1ImageSrc} alt={divImageWithBasePath1ImageAlt} className="img-fluid element-1" {...(divImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath2ImageVisible, divImageWithBasePath2ImageRenderer, (
                <SmartImage src={divImageWithBasePath2ImageSrc} alt={divImageWithBasePath2ImageAlt} className="img-fluid element-2 d-none d-xl-block" {...(divImageWithBasePath2ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeThreeAboutSectionGenerated;
